import React from 'react';
import { useRestApi } from 'hooks/useRestApi';
import { UseRestApiResult } from 'hooks/useRestApi.types';
import { apiUrl } from 'utils/apiUrl';
import { LearnInstanceWithVersions } from '@bb-learn-instances-service/common';
import { useLearnInstance } from 'hooks/useLearnInstance';
import { useTenantContext } from 'contexts/TenantContext';

export interface LearnSiteContextProps {
  fetch?: UseRestApiResult['fetch'];
  loading: boolean;
  site?: Partial<LearnInstanceWithVersions>;
  error?: Error;
}

export const LearnSiteContext = React.createContext<LearnSiteContextProps>({ loading: true });

export const useLearnSiteContext = () => React.useContext(LearnSiteContext);

export const LearnSiteContextProvider: React.FunctionComponent = (props) => {
  const { children } = props;
  const { tenant } = useTenantContext();
  const { learnInstanceId } = useLearnInstance();
  const tenantId = tenant?.tenantType === 'Learn' ? learnInstanceId : tenant?.id;
  const { data, error, loading, ...rest } = useRestApi(
    apiUrl('lct', `tenants/${tenantId}/instances/learnInstances`),
  );

  // Pass error along to handle in page view

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  let context: LearnSiteContextProps = { loading, error, ...rest };

  if (data) {
    context = { site: data, ...context };
  }

  return <LearnSiteContext.Provider value={context}>{children}</LearnSiteContext.Provider>;
};

export default LearnSiteContextProvider;
